import { render, staticRenderFns } from "./proofOfValue.vue?vue&type=template&id=46e5a178&scoped=true"
import script from "./proofOfValue.vue?vue&type=script&lang=js"
export * from "./proofOfValue.vue?vue&type=script&lang=js"
import style0 from "./proofOfValue.vue?vue&type=style&index=0&id=46e5a178&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5a178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e5a178')) {
      api.createRecord('46e5a178', component.options)
    } else {
      api.reload('46e5a178', component.options)
    }
    module.hot.accept("./proofOfValue.vue?vue&type=template&id=46e5a178&scoped=true", function () {
      api.rerender('46e5a178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optimization/proofOfValue.vue"
export default component.exports